import { Grid, Stack } from '@mui/material';

import { useDrawerFilter } from '@hapvida/hapvida-core-components';

import { SearchField, SubHeader } from '@components';
import { NewFilterDrawerBeneficiary } from 'components/filters/NewFiltersParams/NewFilterDrawerBeneficiary';
import { useFilterParams } from '@hooks';

import { useBeneficiariesMobileState } from '../../hooks/useBeneficiariesMobileState';
import { BeneficiariesExportButton } from '../../../desktop/components/BeneficiariesSubHeader/components';

export function BeneficiariesSubHeaderMobile() {
  const { beneficiariesMobileState, beneficiariesSummaryState } =
    useBeneficiariesMobileState();
  const { filterCount } = useDrawerFilter();
  const { hasFilters } = useFilterParams();

  const totalBeneficiariesLength =
    beneficiariesMobileState?.data?.pages[0].total ?? 0;

  const isResultEmpty = totalBeneficiariesLength === 0;

  const isLoading =
    beneficiariesMobileState?.isLoading || beneficiariesSummaryState?.isLoading;
  const hasError =
    beneficiariesMobileState?.isError || beneficiariesSummaryState?.isError;
  const isEmpty = isResultEmpty && !hasFilters;

  if ((isLoading && !hasFilters) || hasError || isEmpty) return null;

  const filterDisabled =
    (!filterCount && beneficiariesMobileState?.isLoading) ||
    (!filterCount && isResultEmpty);

  return (
    <SubHeader>
      <Grid container spacing={3}>
        <Grid item display="flex" gap="16px" width="100%">
          <Stack flexGrow={1}>
            <SearchField
              currentResultLength={totalBeneficiariesLength}
              placeholder="Buscar cód. beneficiário, nome, CPF"
            />
          </Stack>
          <NewFilterDrawerBeneficiary
            subtitle="Selecione como deseja filtrar seus beneficiarios"
            title="Filtrar beneficiarios"
            disabled={filterDisabled}
          />
        </Grid>
        <Grid item xs={12}>
          <BeneficiariesExportButton />
        </Grid>
      </Grid>
    </SubHeader>
  );
}
